import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gauge, CheckSquare, Calendar, LifeBuoy } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-amber" data-id="element-192" />,
    title: 'Guía Digital "Dulces Sueños"',
    desc: 'El Blueprint completo paso a paso.'
  }, {
    icon: <Gauge className="w-6 h-6 text-amber" data-id="element-193" />,
    title: 'El Sistema del Semáforo de Sueño',
    desc: 'Para saber exactamente cuándo intervenir y cuándo esperar.'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-amber" data-id="element-194" />,
    title: 'Checklist de Auditoría del Cuarto',
    desc: 'Elimina los distractores que arruinan el descanso.'
  }, {
    icon: <Calendar className="w-6 h-6 text-amber" data-id="element-195" />,
    title: 'Tracker de 7 Días',
    desc: 'Registra el progreso y ajusta las ventanas de sueño.'
  }, {
    icon: <LifeBuoy className="w-6 h-6 text-amber" data-id="element-196" />,
    title: 'Guía de Crisis',
    desc: 'Qué hacer ante dientes, viajes o regresiones.'
  }];
  return <section className="py-24 bg-cream" data-id="element-197">
      <div className="max-w-5xl mx-auto px-6" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-200">
            Lo que obtienes hoy
          </h2>
          <div className="w-16 h-px bg-amber mx-auto" data-id="element-201"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-navy/5 hover:shadow-md transition-shadow" data-id="element-203">
              <div className="w-12 h-12 bg-amber/10 rounded-xl flex items-center justify-center mb-6" data-id="element-204">
                {item.icon}
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-205">
                {item.title}
              </h3>
              <p className="text-navy/70" data-id="element-206">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}